import { FC, Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// Redux
import { useAppDispatch } from 'hooks/useStore';
// Async
import { getResult } from 'store/player/playerAsync';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import PlayerResult from 'components/PlayerResult';
import RoktIntegration from 'components/RoktIntegration';
// Hooks
import LeaderboardButton from './LeaderboardButton';
import TopBuckets from './TopBuckets';
import ProceedData from './ProceedData';

const PostQuizPage:FC = () => {
  const { slug } = useParams<{ slug:string }>();
  // Dispatch
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getResult({ quizName: slug, limit: 96 }))
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <PublicDevicePlayable />
      <AppBar  />
      <div className="grow p-4 overflow-y-auto">
        <LeaderboardButton />
        <ProceedData />
        <TopBuckets />
      </div>
      <PlayerResult />
      <RoktIntegration />
    </Fragment>
  )
}

export default PostQuizPage;
